export const BpmnElements = {
    startEvent: "StartEvent",
    userTask: "UserTask",
    manualTask: "ManualTask",
    serviceTask: "ServiceTask",
    dataObject: "DataObjectReference",
    dataStore: "DataStoreReference",
    sendTask: "SendTask",
    messageEventDefinition: "MessageEventDefinition",
    receiveTask: "ReceiveTask",
    intermediateCatchEvent: "IntermediateCatchEvent"
}